/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audit_Details_Project_Private_Chats_Enabled_DescInputs */



/**
* | output |
* | --- |
* | "Private chats were turned on for project \"{name}\": members now only see their own chats, attached files and AI-created documents, unless they are allowed to ..." |
*
* @param {Audit_Details_Project_Private_Chats_Enabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_project_private_chats_enabled_desc = /** @type {((inputs: Audit_Details_Project_Private_Chats_Enabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Project_Private_Chats_Enabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Private Chats wurden für das Projekt "${i?.name}" aktiviert: Mitglieder sehen jetzt nur noch ihre eigenen Chats, angehängten Dateien und KI-erstellten Dokumente, es sei denn, sie dürfen die Chats aller Mitglieder sehen.`)
	return /** @type {LocalizedString} */ (`Private chats were turned on for project "${i?.name}": members now only see their own chats, attached files and AI-created documents, unless they are allowed to see everyone's chats.`)
});